// deviceModule/index.js
export { useDevice } from './hooks/useDevice';